import { render, staticRenderFns } from "./Writings.vue?vue&type=template&id=59dd6d8a&"
import script from "./Writings.vue?vue&type=script&lang=js&"
export * from "./Writings.vue?vue&type=script&lang=js&"
import style0 from "./Writings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports